import script from "./ArtistProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistProfile.vue?vue&type=script&setup=true&lang=js"

import "./ArtistProfile.vue?vue&type=style&index=0&id=1024422d&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1024422d"]])

export default __exports__